import React, {ReactElement, Fragment} from 'react'
import useImageLogType from '../hooks/useImageLogType'
import Select from 'react-select'
import useLookup from '../hooks/useLookup'
import {Asset, ImageLogType} from "../../../types";
import { debounce } from 'lodash'

interface Props {
    value: string,
    onChange: (value: string) => void,
    label: string
}

export default function ImageLogTypeSelector(props: Props): ReactElement {
    const [imageLogType, loading] = useImageLogType()
    const [lookup, updateLookup] = React.useState(props.value)

    const onChange = React.useCallback(
        debounce(x => props.onChange(x), 1000),
        []
    )

    return (
        <Fragment>
            <label htmlFor={'imagelogtype-selector'}>{props.label}</label>
            <Select
                role="change-imagelogtype"
                inputId={'imagelogtype-selector'}
                options={imageLogType}
                loading={loading}
                labelKey={'key'}
                valueKey={'value'}
                value={lookup}
                onChange={(item: ImageLogType) => {
                    updateLookup(item.value)
                    onChange(item.value)
                }}
            />
        </Fragment>
    )
}
